import React from 'react';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '../lib/cookieConsent';
import LegalPage from '../components/LegalPage';

const ReopenLink = () => {
  const { openSettings } = useCookieConsent();
  return (
    <p className="text-base text-stone-700 font-light leading-relaxed mt-4">
      Puedes modificar tu elección en cualquier momento desde el enlace{' '}
      <button
        type="button"
        onClick={openSettings}
        className="text-cyan-vidat underline underline-offset-2 hover:text-[#17306a]"
        data-testid="cookies-page-reopen-settings"
      >
        Configurar cookies
      </button>
      .
    </p>
  );
};

const CookiesPolicy = () => (
  <>
    <LegalPage
      testId="page-cookies"
      metaTitle="Política de Cookies | VIDAT"
      title="Política de Cookies"
      subtitle="Información sobre el uso de cookies en la web de VIDAT."
      sections={[
        {
          title: '¿Qué son las cookies?',
          body: [
            'Las cookies son pequeños archivos que se almacenan en el dispositivo de la persona usuaria cuando visita una página web. Pueden servir para permitir el funcionamiento técnico de la web, recordar preferencias o analizar el uso del sitio.',
          ],
        },
        {
          title: 'Tipos de cookies que puede utilizar esta web',
          body: [
            'La web de VIDAT puede utilizar las siguientes categorías de cookies:',
            { type: 'subtitle', text: 'a) Cookies técnicas o necesarias' },
            'Son necesarias para el funcionamiento básico de la web y no requieren consentimiento. Permiten, por ejemplo, la navegación, la seguridad, la carga correcta de páginas o el funcionamiento de formularios.',
            { type: 'subtitle', text: 'b) Cookies de preferencias' },
            'Permiten recordar determinadas opciones elegidas por la persona usuaria, como preferencias de visualización o configuración.',
            { type: 'subtitle', text: 'c) Cookies analíticas' },
            'Permiten obtener información sobre cómo se utiliza la web, qué páginas se visitan y cómo mejorar la experiencia de navegación. Solo se utilizarán si la persona usuaria las acepta.',
            { type: 'subtitle', text: 'd) Cookies de terceros' },
            'En caso de utilizar herramientas externas, como sistemas de analítica, formularios, mapas, vídeos incrustados o servicios similares, estas herramientas podrían instalar cookies propias de terceros. Solo se activarán cuando corresponda y de acuerdo con la configuración elegida por la persona usuaria.',
          ],
        },
        {
          title: 'Finalidad de las cookies',
          body: [
            'Las cookies pueden utilizarse para:',
            { type: 'list', items: [
              'Garantizar el funcionamiento técnico de la web.',
              'Mejorar la experiencia de navegación.',
              'Analizar de forma agregada el uso de la página.',
              'Recordar preferencias de configuración.',
              'Integrar servicios externos necesarios para determinadas funcionalidades.',
            ] },
          ],
        },
        {
          title: 'Gestión del consentimiento',
          body: [
            'Al acceder por primera vez a la web, la persona usuaria podrá:',
            { type: 'list', items: [
              'Aceptar todas las cookies.',
              'Rechazar todas las cookies no necesarias.',
              'Configurar sus preferencias.',
            ] },
            'La persona usuaria podrá modificar o retirar su consentimiento en cualquier momento desde el enlace “Configurar cookies” disponible en la web.',
          ],
        },
        {
          title: 'Cómo desactivar cookies desde el navegador',
          body: [
            'La persona usuaria también puede bloquear o eliminar cookies desde la configuración de su navegador. La desactivación de algunas cookies puede afectar al funcionamiento de determinadas partes de la web.',
          ],
        },
        {
          title: 'Actualización de la Política de Cookies',
          body: [
            'VIDAT podrá actualizar esta Política de Cookies en función de cambios técnicos, normativos o de los servicios utilizados en la web.',
          ],
        },
      ]}
    />
    <section className="bg-white py-16">
      <div className="max-w-[900px] mx-auto px-6 lg:px-12">
        <ReopenLink />
      </div>
    </section>
  </>
);

export default CookiesPolicy;
